import collateLoginErrors from '../LoginForm/collateErrors';
import collateRegistrationErrors from '../RegistrationForm/collateErrors';

export default function collateErrors(values, props, json) {
    const { messages } = props;
    
    if (json && json.errors) {
        const errors = {};

        if (values.hasAccount === 'true' || values.formType === 'login') {
            const { logonId, _error, ...rest } = collateLoginErrors(
                { logonId: values.logonId, ...values.login },
                { ...props, loginSectionName: 'login' },
                json,
            );
            errors.logonId = logonId;
            errors._error = _error;
            errors.login = rest;
        } else if (values.formType === 'registration') {
            let { registrationEmail, _error, ...rest } = collateRegistrationErrors(
                { registrationEmail: values.registrationEmail, ...values.registration },
                { registrationSectionName: 'registration', ...props },
                json,
            );
            errors.registrationEmail = registrationEmail;
            errors._error = _error;
            errors.registration = rest;
        } else {
            json.errors.forEach(({ errorKey }) => {
                switch (errorKey) {
                    case '_ERR_VALUE_FOR_PARM_NOT_SUPPORTED':
                        errors.guestEmail = messages.errors.invalid({ field: messages.loginOrGuestForm.logonId() });
                        break;
                    case 'ERR_USER_FULL_USER_ALREADY_EXISTS':
                        errors._error = messages.loginOrGuestForm.errors.userExists();
                        break;
                    default:
                        errors._error = messages.errors.generic();
                }
            });
        }

        return { ...errors };
    }

    return { _error: messages.errors.unknown() };
}
